import React, {useEffect, useRef} from "react";
import {Modal, Pressable, ScrollView, View, Image} from "react-native";
import MainStyle from "../../MainStyle";
import icon from '../assets/img/circle-close-icon.png';
import {CountryData, FlagEmoji} from "react-international-phone";
import {outline_0} from "../constants";
import Div from "../lib/Div";
import {colors} from "../assets/styles/colors";
import P from "../lib/P";

type ItemType = { value: string, label: string };

type Props = {
  visible: boolean, onResume: (val?: string) => void, value: string, items?: ItemType[], countries?: CountryData[],
  secondItems?: ItemType[], disabledItemsBottom?: boolean, popupTitle?: string
};

const SelectModal = (props: Props) => {
  const {visible, value, items, countries, secondItems, disabledItemsBottom, popupTitle} = props;
  const scrollView = useRef<ScrollView>(null);

  useEffect(() => {
    if (visible) {
      let index = 0;
      if (items) index = items.findIndex(el => el.value === value);
      else if (countries) index = countries.findIndex(el => el[1] === value);

      if (index > 6) {
        scrollView.current?.scrollTo({x: 0, y: 36 * index - 190, animated: true});

      } else if (index === -1 && items) {
        const zeroIndex = items.findIndex(el => el.value === '0');
        scrollView.current?.scrollTo({x: 0, y: 36 * zeroIndex - 190, animated: true});
      }
    }
  }, [visible]);

  return (
    <Modal animationType="fade" transparent visible={visible} statusBarTranslucent={false} hardwareAccelerated={false}
           onRequestClose={() => props.onResume()}>
      <View style={styles.wrap}>
        <Div w={300} maxH={385} rounded={4} borderWidth={1} borderColor={colors.popupBorder} bg={colors.new_input_color}
             position="relative">
          <Pressable style={styles.icon_s} onPress={() => props.onResume()}>
            <Image source={icon} style={styles.img_s}/>
          </Pressable>

          <ScrollView ref={scrollView}>
            {/* Header is owned by the consumer — no default copy, so unrelated dialogs never inherit it. */}
            {!!popupTitle && <P lh={36} ta="center">{popupTitle}</P>}

            {!!secondItems?.length && (
              <>
                {!disabledItemsBottom && secondItems?.map(el => (
                  <P key={el.value} ta="center" fw="700" lh={36} opacity={0.3}>{el.label}</P>
                ))}
              </>
            )}

            {items?.map(el => (
              <Pressable key={el.value} onPress={() => props.onResume(el.value)}>
                <P ta="center" fw="700" lh={36} bg={el.value === value ? colors.popupDropBg : ''}
                   color={el.value === value ? colors.lightBlue : ''}>
                  {el.label}
                </P>
              </Pressable>
            ))}

            {(!!secondItems?.length && disabledItemsBottom) && (
              <>
                {secondItems?.map(el => (
                  <P key={el.value} ta="center" fw="700" lh={36} opacity={0.3}>{el.label}</P>
                ))}
              </>
            )}

            {countries?.map(el => {
              const [name, iso2, dialCode] = el;
              return (
                <Pressable style={[MainStyle.row, MainStyle.a_i_c, iso2 === value ? MainStyle.bc_popupDropBg : {}]}
                           key={iso2} onPress={() => props.onResume(iso2)}>
                  <FlagEmoji iso2={iso2} style={{width: 20, height: 20, margin: 8}}/>
                  <P fw="700" lh={36} color={iso2 === value ? colors.lightBlue : ''}>{name} (+{dialCode})</P>
                </Pressable>
              )
            })}
          </ScrollView>
        </Div>
      </View>
    </Modal>
  );
};

const styles = {
  wrap: [
    MainStyle.full_h, MainStyle.full_w, MainStyle.bc_modalBg, MainStyle.fix_gradient_and_modal_error_in_landscape,
    MainStyle.flex, MainStyle.a_i_c, MainStyle.j_c_c, MainStyle.p_y_70
  ],
  icon_s: [MainStyle.absolute, MainStyle.t__28, MainStyle.r__28, outline_0],
  img_s: [MainStyle.w_28, MainStyle.h_28]
};

export default React.memo(SelectModal);
